import React, { useEffect, useState } from "react";
import { Box, SimpleGrid, Text } from "@chakra-ui/react";

import LoadingOverlay  from "../components/Profile/LoadingOverlay";
import ProfileCard      from "../components/Profile/ProfileCard";
import AddUserCard      from "../components/Profile/AddUserCard";

import {
  getUserById,
  getCustomerById,
  updateUser,
} from "../services/api";

export default function Profile() {
  const [user, setUser]               = useState(null);
  const [customerName, setCustomerName] = useState("—");
  const [isLoading, setIsLoading]     = useState(true);

  /* ---- UTENTE LOGGATO (localStorage) ---- */
  const rawUser    = localStorage.getItem("user");
  const parsedUser =
    rawUser && rawUser !== "undefined" ? JSON.parse(rawUser) : null;

  /* ---- FETCH dati utente / azienda ---- */
  const fetchData = async () => {
    if (!parsedUser?.id) return;

    try {
      const resUser = await getUserById(parsedUser.id);
      setUser(resUser.data);

      if (parsedUser.customer_id) {
        const resCust = await getCustomerById(parsedUser.customer_id);
        setCustomerName(resCust.data.company_name || "—");
      }
    } catch {
      console.error("Errore nel recupero dati utente/azienda");
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchData().finally(() => setIsLoading(false));
  }, []);

  /* ---- SALVATAGGIO dati profilo ---- */
  const handleSave = async ({ email, phone }) => {
    try {
      await updateUser(parsedUser.id, {
        ...user,
        email,
        phone,
        updated_at: new Date().toISOString(),
      });
      fetchData(); // refresh
    } catch (err) {
      console.error("Errore nel salvataggio:", err);
    }
  };

  /* ---- RENDER ---- */
  if (isLoading) return <LoadingOverlay />;

  if (!user) return <Text color="red.500">Utente non trovato.</Text>;

  return (
    <Box py={10} px={4}>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
        {/* Card profilo */}
        <ProfileCard
          user={user}
          customerName={customerName}
          onSave={handleSave}
          refresh={fetchData}
        />

        {/* Card aggiunta utente */}
        <AddUserCard /* setUsers è opzionale qui */ />
      </SimpleGrid>
    </Box>
  );
}
